import React, { Component, Fragment } from "react";
import { connect } from "@common/components/base.component";
import solicitarDocumentoSelector from "../store/solicitarDocumento.selectors";
import solicitarDocumentoActions from "../store/solicitarDocumento.actions";
import autoBind from "react-autobind";
import StaticGrid from "@common/components/grid/staticGrid.component";
import Button from '@material-ui/core/Button';
import RedeSIMHeader from "../../redeSIM.header";
import { ddados } from "../solicitarDocumento.ddados";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    const options = {
      filterVersion: Math.random(),
      noStorage: true,
      webStorage: "RedeSIM.SolicitarDocumento",
      applySearchOnLoad: true,
      isNotCheckable: true,
    };

    const columns = [
      {
        fieldName: "Protocolo",
        dataName: "Protocolo",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Cnpj",
        dataName: "NrCnpj",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Nome Empresa",
        dataName: "NomeEmpresa",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Ccm",
        dataName: "Ccm",
        show: true,
        type: "number",
        removeFilter: true
      },
    ];

    const actions = [
      {
        title: "Solicitar Documento",
        icon: "fas fa-check",
        onClick: async dataItem => {
          this.props.solicitarDocumentoActions.abrirSolicitacaoDocumento(dataItem);
        }
      }
    ];

    const order = [
      { fieldName: "Protocolo", dataName: "Protocolo", order: "A" }
    ];

    const toolbar = {
      title: "",
      prefix: " ",
      tools: {
        limpar: false
      }
    };

    this.config = {
      order,
      columns,
      actions,
      options,
      toolbar
    };
  }

  onClose(){
    this.props.solicitarDocumentoActions.setPesquisaDocumento([]);
  }

  render() {
    const { solicitarDocumento } = this.props.solicitarDocumentoSelector;
    const { GridSolicitarDocumentoPesquisa } = solicitarDocumento;
    const { Titulo } = ddados;

    return (
      <Fragment>
        <h2 className={"mb-4 mt-2"}>{Titulo}</h2>
        <StaticGrid {...this.config} itens={GridSolicitarDocumentoPesquisa.asMutable()}></StaticGrid>
          <div style={{ textAlign: 'right' }}>
            <Button variant="outlined" color="primary" onClick={this.onClose}>
                      <i className={"mr-1 fa fa-angle-double-left"} />{" "}
                      {"Voltar"}
            </Button>
          </div>
      </Fragment>
    );
  }
}

export default connect({
  actions: {
    solicitarDocumentoActions
  },
  selectors: {
    solicitarDocumentoSelector
  }
})(Container);
